import swal from 'sweetalert2';

export class AlertHandler {

  constructor() {
  }

  public static SuccessAlert(title: any, ms?: number, customClass?: string, enableTimer: boolean = true) {
    if (enableTimer) {
      swal.fire({
        icon: 'success',
        title,
        showConfirmButton: false,
        timer: ms || 2500,
        customClass: {
          popup: customClass || 'swal-wide-sm'
        }
      });
    } else {
      swal.fire({
        icon: 'success',
        title,
        showConfirmButton: false,
        customClass: {
          popup: customClass || 'swal-wide-sm'
        }
      });
    }
  }

  public static InfoAlert(title: any, ms?: number, customClass?: string, enableTimer: boolean = true) {
    if (enableTimer) {
      swal.fire({
        icon: 'info',
        title,
        showConfirmButton: false,
        timer: ms || 2500,
        customClass: {
          popup: customClass || 'swal-wide-sm'
        }
      });
    } else {
      swal.fire({
        icon: 'info',
        title,
        showConfirmButton: false,
        customClass: {
          popup: customClass || 'swal-wide-sm'
        }
      });
    }
  }
  public static SuccessUploadAlert(title: any, ms?: number, customClass?: string) {
    return swal.fire({
      icon: 'success',
      title: title,
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: customClass || 'swal-wide-sm'
      }
    }).then(function () { return 'closed' });
  }


  public static deleteAlert(title: any, ms?: number, customClass?: string) {
    return swal.fire({
      icon: 'question',
      title: title,
      showConfirmButton: true,
      showCancelButton: true,
      showCloseButton: true,
      customClass: {
        popup: customClass || 'swal-wide-sm'
      }
    }).then(function (result) {
      if (result.value) {
        return 'confirm';
      } else if (result.dismiss) {
        return 'cancel';
      }

    });
  }

  public static WarningAlert(title: any, ms?: number, customClass?: string, enableTimer: boolean = true) {
    if (enableTimer) {
      swal.fire({
        icon: 'warning',
        title,
        showConfirmButton: false,
        timer: ms || 2500,
        customClass: {
          popup: customClass || 'swal-wide-sm'
        }
      });
    } else {
      swal.fire({
        icon: 'warning',
        title,
        showConfirmButton: true,
        customClass: {
          popup: customClass || 'swal-wide-sm'
        }
      });
    }
  }

  public static WarningUploadAlert(title: any, ms?: number, customClass?: string, enableTimer: boolean = true) {
    if (enableTimer) {
      swal.fire({
        icon: 'warning',
        title: title,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: {
          popup: customClass || 'swal-wide-sm'
        }
      });
    } else {
      swal.fire({
        icon: 'warning',
        title,
        showConfirmButton: true,
        customClass: {
          popup: customClass || 'swal-wide-sm'
        }
      });
    }
  }

  public static ErrorAlert(title: any, ms?: number, customClass?: string, enableTimer: boolean = true) {
    if (enableTimer) {
      swal.fire({
        icon: 'error',
        title,
        showConfirmButton: false,
        timer: ms || 2500,
        didOpen: () => {
          document.body.classList.remove('swal2-height-auto');
        },
        customClass: {
          popup: customClass || 'swal-wide-sm'
        }
      });
    } else {
      swal.fire({
        icon: 'error',
        title,
        showConfirmButton: true,
        customClass: {
          popup: customClass || 'swal-wide-sm'
        }
      });
    }
  }



  public static ErrorUploadAlert(title: any, ms?: number, customClass?: string, enableTimer: boolean = true) {
    if (enableTimer) {
      swal.fire({
        icon: 'error',
        title: title,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: {
          popup: customClass || 'swal-wide-sm'
        }
      })


    } else {
      swal.fire({
        icon: 'error',
        title,
        showConfirmButton: true,
        customClass: {
          popup: customClass || 'swal-wide-sm'
        }
      });

    }
  }


  public static DetailedErrorAlert(title: any, customClass?: string) {
    swal.fire({
      icon: 'error',
      title,
      showConfirmButton: true,
      customClass: {
        popup: customClass || 'swal-wide-sm'
      }
    });
  }

  public static DetailedWarningAlert(title: any, customClass?: string) {
    swal.fire({
      icon: 'warning',
      title,
      showConfirmButton: true,
      customClass: {
        popup: customClass || 'swal-wide-sm'
      }
    });
  }

  public static Confirm(title: string | null, options: any = {}, callback?: any) {
    swal.fire({
      title: title,
      html: options.html || null,
      icon: options.type || 'warning',
      customClass: {
        container: 'confirm-box-container',
        closeButton: 'confirm-box-close-btn',
        confirmButton: 'confirm-box-confirm-btn',
        cancelButton: 'confirm-box-cancel-btn'
      },
      showConfirmButton: options.showConfirmButton || true,
      confirmButtonColor: options.confirmButtonColor || '#ffe600',
      cancelButtonColor: options.cancelButtonColor || '#474646',
      showCancelButton: options.showCancelButton || true,
      confirmButtonText: options.confirmButtonText || '<i class="fa fa-check" aria-hidden="true"></i>&nbsp;&nbsp;Yes',
      cancelButtonText: options.concelButtonText || '<i class="fa fa-times" aria-hidden="true"></i>&nbsp;&nbsp;Cancel'


    }).then((result: any) => {
      callback(result.value || false)
    })
  }

}
